import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import type { CmsApiPagePage } from '#/modules/cms/api/types/CmsApiPage';
import { getCmsApiPageDefaultSearchType } from '#/modules/cms/helpers/getCmsApiPageDefaultSearchType';
import { getContentUrlByLocale } from '#/modules/cms/helpers/getContentUrlByLocale';
import { getHideFooterDivider } from '#/modules/cms/helpers/getHideFooterDivider';
import { getIsNoAdPage } from '#/modules/cms/helpers/getIsNoAdPage';

type Args = {
  content: CmsApiPagePage;
};

export function getCmsPagePageLayoutHandleProps({
  content,
}: Args): LayoutHandleProps {
  const defaultSearchType = getCmsApiPageDefaultSearchType({ content });

  // banner ads should not be on some pages
  const noAds = getIsNoAdPage(content);

  const hero = content.heroSearch?.onlyResults ? undefined : content.heroSearch;

  const hideFooterDivider = getHideFooterDivider({ content });
  const urlByLocale = getContentUrlByLocale({ content });

  return {
    noAds,
    defaultSearchType,
    hideFooterDivider,
    urlByLocale,
    showDesktopSearch: !hero,
    searchFromPageType: 'CMS',
  };
}
